import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {freezeStoresStatesHook} from './app/common/elf-store/hooks';

if (environment.production) {
  enableProdMode();
}

freezeStoresStatesHook();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
